import React from 'react';
import ClassAssembly11C from 'views/ClassAssembly10D';

const ClassAssembly11CPage = () => {
    return <ClassAssembly11C />;
  };
  
  export default ClassAssembly11CPage;

  //11C